import { render, staticRenderFns } from "./contractAgent.vue?vue&type=template&id=87a53d30&scoped=true"
import script from "./contractAgent.vue?vue&type=script&lang=js"
export * from "./contractAgent.vue?vue&type=script&lang=js"
import style0 from "./contractAgent.vue?vue&type=style&index=0&id=87a53d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a53d30",
  null
  
)

export default component.exports